import React, { useContext } from 'react'
import { SessionContext } from 'data/context'
import { Container } from './Styled'
import Button from '@material-ui/core/Button'

export const Header: React.FC<{
  setShowForm: (param: boolean) => void
}> = ({ setShowForm }) => {
  const { readOnly } = useContext(SessionContext)
  return (
    <Container>
      <h4>Permanent Stock Inventory</h4>
      {!readOnly && (
        <Button
          variant='contained'
          color='secondary'
          onClick={() => setShowForm(true)}
        >
          Create
        </Button>
      )}
    </Container>
  )
}
